import { EstimationType, PropertyType } from '@/types';

export const ESTIMATION_TYPES: Array<{
  value: EstimationType;
  title: string;
  description: string;
}> = [
  {
    value: 'prix',
    title: 'Estimation de prix',
    description: 'Obtenez une estimation du prix de vente',
  },
  {
    value: 'loyer',
    title: 'Estimation de loyer',
    description: 'Obtenez une estimation du loyer annuel',
  },
];

export const PROPERTY_TYPES: Array<{
  value: PropertyType;
  title: string;
  icon: string;
}> = [
  { value: 'bureaux', title: 'Bureaux', icon: '🏢' },
  { value: 'commerce', title: 'Commerce', icon: '🪟' },
  { value: 'local-activite', title: 'Local d\'activité', icon: '🏭' },
  { value: 'industriel', title: 'Industriel', icon: '⚙️' },
];

export const USER_PROFILES_SALE = [
  { value: 'acheteur', title: 'Acheteur', icon: '👤' },
  { value: 'vendeur', title: 'Vendeur', icon: '🏷️' },
  { value: 'professionnel', title: 'Professionnel', icon: '💼' },
];

export const USER_PROFILES_RENTAL = [
  { value: 'locataire', title: 'Locataire', icon: '🔑' },
  { value: 'proprietaire', title: 'Propriétaire bailleur', icon: '🏠' },
  { value: 'professionnel', title: 'Professionnel', icon: '💼' },
];




